export default "__VITE_ASSET__CIREQoAR__"